import React, { useEffect, useState } from 'react';
import { TextField } from 'material-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './HSIdsCodes.scss';

/**
 * 
 * @param {{ 
 *  cargoIndex: number, 
 *  cargoOrder: any, 
 *  numberOrderTable: number,
 *  changeCargo: Function }} value
 */
function DetailsForCargo({ 
    cargoIndex, cargoOrder, changeCargo,
}) {
    const [value, setValue] = useState(cargoOrder ? cargoOrder.cargo[cargoIndex].additionalCargoDetails : undefined);
    
    useEffect(() => {
        if (cargoOrder) {
            changeCargo([{
                field: `cargo.${cargoIndex}.additionalCargoDetails`,
                value: value || undefined,
            }]);
        }
    }, [value]);

    return (
        <div 
            id='details-for-cargo'
            className='row'
        >
            <div className='column-left'>
                Details for cargo:
            </div>
            <div className='column-right'>
                <TextField
                    className='details-for-cargo_value'
                    value={value || ''}
                    hintText='Additional details'
                    hintStyle={{ fontSize: '13px' }}
                    style={{ fontSize: '13px' }}
                    onChange={e => setValue(e.target.value)}
                />
            </div>
        </div>
    );
}

DetailsForCargo.propTypes = {
    cargoOrder: PropTypes.any,
    numberOrderTable: PropTypes.number,
};

DetailsForCargo.defaultProps = {
    cargoOrder: undefined,
    numberOrderTable: 0,
};

export default React.memo(connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        return {
            numberOrderTable: ownProps.numberOrderTable,
            cargoOrder,
        };
    },
    null,
)(DetailsForCargo));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/DetailsForCargo.jsx